import React, { useState, useContext, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import styles from "./datasetCreate.module.css";
import SimpleBackIcon from "../../assets/simpleBackIcon.svg";
import DownIcon from "../../assets/DownIcon";
import InfoIcon from "../../assets/InfoIcon";
import { ReloadIcon } from "../../assets/ReloadIcon";
import AttributePopup from "./AttributePopup";
import { useAsyncFn } from "../../hooks/use-async-fn";
import { AuthContext } from "../../contexts/auth-context";
import { FormContext } from "../../contexts/form-context";
import { BUCKET_FORM_FIELDS } from "../../enums";
import { useSidebar } from "../NewSideBar/SidebarContext";
import { useBreadcrumb } from "../Breadcrumb/BreadcrumbContext";
import InfoPopup from "../InfoPopup";
import { Tooltip } from "../Tooltip";
import PageNotFound from "../PageNotFound";
import LayoutContainer from "../LayoutContainer";
import config from "../../config";
import { useToast } from "../../contexts/toast-context";
import { OI } from "../../onam/mark";
import { FEATURES } from "../../onam/features";

const GENERIC_ERROR_MESSAGE = "Something went wrong.";

const DatasetCreatePage = () => {
  const {
    appMetadata,
    user,
    getTablesByDataSourceId,
    getTablesByName,
    putBuckets,
    getDatasourceByFedId,
    getLogoFederationID,
    getConfig,
    getorganizationById,
    getLimitsUsage,
  } = useContext(AuthContext);
  const { fields, validateForm } = useContext(FormContext);
  const { showToast } = useToast();
  const [datasetName, setDatasetName] = useState("");
  const [databaseTable, setDatabaseTable] = useState("");
  const [matchId, setMatchId] = useState("");
  const [canonicalIdentityType, setCanonicalIdentityType] = useState("");
  const [attributePopup, setShowAttributePopup] = useState(false);
  const [failureMessage, setFailureMessage] = useState(null);
  type AttrValue = string | boolean;

  const [attributesChips, setAttributesChips] = useState<
    Record<string, AttrValue[]>
  >({});

  const [attributesType, setAttributeType] = useState<
    Record<string, AttrValue>
  >({});

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const [isMatchIdDropdownOpen, setIsMatchIdDropdownOpen] = useState(false);
  const matchIdDropdownRef = useRef<HTMLDivElement | null>(null);
  const [isDbTableDropdownOpen, setIsDbTableDropdownOpen] = useState(false);
  const dbTableDropdownRef = useRef<HTMLDivElement | null>(null);
  const [matchIdSearchQuery, setMatchIdSearchQuery] = useState("");
  const [dbTableDropdownStyle, setDbTableDropdownStyle] =
    useState<React.CSSProperties>({});
  const [matchIdDropdownStyle, setMatchIdDropdownStyle] =
    useState<React.CSSProperties>({});
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [selectedFeds, setSelectedFeds] = useState([]);
  const [opensucceessDataset, setOpensucceessdataset] = useState(false);
  const [dbTextInput, setDbTextInput] = useState("");
  type TableCommitState = "idle" | "validating" | "confirmed" | "failed";
  const [tableCommitState, setTableCommitState] =
    useState<TableCommitState>("idle");
  const tableEntrySourceRef = useRef<"dropdown" | "manual">("dropdown");
  const [tablesError, setTablesError] = useState<string | null>(null);
  const [tablesConnecting, setTablesConnecting] = useState(false);
  const tablesRequestIdRef = useRef(0);
  const [databaseTableError, setDatabaseTableError] = useState<string | null>(
    null,
  );
  const userRole = localStorage.getItem("userRole");
  const isPlatformOrAppAdmin =
    userRole === config.superUserRole ||
    userRole === config.applicationAdminRole;
  const selectedOrgId =
    localStorage.getItem("selectedOrganizationId") === "null"
      ? null
      : localStorage.getItem("selectedOrganizationId");
  const selectedOrganizationName =
    localStorage.getItem("selectedOrganizationName") === "null"
      ? null
      : localStorage.getItem("selectedOrganizationName");
  let tenantObj = {};
  tenantObj = appMetadata && Object.values(appMetadata);
  var userOrganization;
  userOrganization =
    isPlatformOrAppAdmin && selectedOrgId
      ? selectedOrgId
      : tenantObj[0].organization;
  let userOrganizationName =
    isPlatformOrAppAdmin && selectedOrganizationName
      ? selectedOrganizationName
      : tenantObj[0].organization_name;
  const userOrgId = tenantObj[0].organization;
  const getOrgByIdFn = useAsyncFn({
    deferFn: getorganizationById,
    organizationID: userOrgId,
  });
  const userOrgName = getOrgByIdFn.data?.name ?? tenantObj[0].organization_name;
  console.log("[DatasetCreate] appMetadata:", appMetadata);
  console.log("[DatasetCreate] tenantObj[0]:", tenantObj[0]);
  console.log(
    "[DatasetCreate] userOrgId:",
    userOrgId,
    "userOrgName (resolved):",
    userOrgName,
  );
  const { mainMenuItems, setActiveSubItem, setIsSideBarMenuDisabled } =
    useSidebar();
  const { setBreadcrumbItems } = useBreadcrumb();
  const sessionFederationId =
    localStorage.getItem("federationkey") === "null"
      ? null
      : localStorage.getItem("federationkey");
  const history = useHistory();

  const [fedList, setFedList] = useState([]);
  const [fedSearchLoading, setFedSearchLoading] = useState(false);
  const [fedNextCursor, setFedNextCursor] = useState<string | null>(null);
  const [fedLoadingMore, setFedLoadingMore] = useState(false);
  const fedSearchDebounceRef = useRef<ReturnType<typeof setTimeout> | null>(
    null,
  );
  const fedSearchQueryRef = useRef<string>("");

  const loadFederations = async (search: string, cursor?: string) => {
    if (cursor) {
      setFedLoadingMore(true);
    } else {
      setFedSearchLoading(true);
    }
    try {
      const result = await getLogoFederationID({
        args: {
          organizationID: userOrganization,
          name: search,
          page_size: 8,
          cursor,
        },
      });
      if (cursor) {
        setFedList((prev) => [...prev, ...(result?.items ?? [])]);
      } else {
        setFedList(result?.items ?? []);
      }
      setFedNextCursor(result?.pagination?.next_cursor ?? null);
    } catch {
      // ignore
    } finally {
      if (cursor) {
        setFedLoadingMore(false);
      } else {
        setFedSearchLoading(false);
      }
    }
  };

  const handleFedSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    fedSearchQueryRef.current = value;
    if (fedSearchDebounceRef.current)
      clearTimeout(fedSearchDebounceRef.current);
    fedSearchDebounceRef.current = setTimeout(
      () => loadFederations(value),
      300,
    );
  };
  const popupRef = useRef(null);
  const putBucketsFn = useAsyncFn({
    deferFn: putBuckets,
  });
  const getConfigFn = useAsyncFn({
    deferFn: getConfig,
  });
  const getTablesFn = useAsyncFn({
    deferFn: getTablesByDataSourceId,
    organizationId: userOrganization,
  });
  const getTablesNameFn = useAsyncFn({
    deferFn: getTablesByName,
    organizationId: userOrganization,
  });
  const attributesResult = getTablesNameFn.data && getTablesNameFn.data.Cols;
  const { data: dataSourceData, run: fetchDataSourceById } = useAsyncFn({
    deferFn: getDatasourceByFedId,
    organizationId: userOrganization,
  });

  useEffect(() => {
    getOrgByIdFn.run({ organizationID: userOrgId }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchDataSourceById().catch(() => {
      setFailureMessage(GENERIC_ERROR_MESSAGE);
      return null;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [sourceId, setSourceId] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (dataSourceData?.Count > 0 && dataSourceData.Items?.[0]?.id) {
      setSourceId(dataSourceData.Items[0].id);
    }
  }, [dataSourceData]);

  useEffect(() => {
    fetchDataSourceById().catch(() => {
      setFailureMessage(GENERIC_ERROR_MESSAGE);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    getConfigFn.run({ organizationId: userOrganization }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isDropdownOpen) loadFederations("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDropdownOpen]);

  const loadDatabaseTables = (datasourceId: string) => {
    const requestId = ++tablesRequestIdRef.current;
    const isCurrent = () => tablesRequestIdRef.current === requestId;
    setTablesError(null);
    setTablesConnecting(false);
    getTablesFn
      .run({
        datasourceId,
        organizationId: userOrganization,
        onRetry: () => {
          if (isCurrent()) setTablesConnecting(true);
        },
      })
      .catch((err) => {
        if (!isCurrent() || err?.name === "AbortError") return;
        setTablesError(err?.message || GENERIC_ERROR_MESSAGE);
      })
      .finally(() => {
        if (isCurrent()) setTablesConnecting(false);
      });
  };

  useEffect(() => {
    if (sourceId) {
      loadDatabaseTables(sourceId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sourceId]);

  useEffect(() => {
    setMatchId("");
    if (databaseTable) {
      setDatabaseTableError(null);
      getTablesNameFn
        .run({
          tableName: databaseTable,
          datasourceId: sourceId,
          organizationId: userOrganization,
        })
        .then(async () => {
          if (tableEntrySourceRef.current === "manual") {
            setTableCommitState("confirmed");
          }
          if (!sessionFederationId) return;
          try {
            const objectives = JSON.parse(
              localStorage.getItem("allowedQueryObjectives") || "[]",
            );
            const data = await getLimitsUsage({
              args: {
                organizationId: userOrganization,
                federationId: sessionFederationId,
                queryType: objectives?.[0] || "activation",
              },
            });
            const selected = databaseTable.trim().toLowerCase();
            const isDisabled = (data?.usage_by_query_type ?? []).some(
              (entry) =>
                entry.table_usage?.some(
                  (t) =>
                    !t.enabled_flag &&
                    t.physical_table_name?.trim().toLowerCase() === selected,
                ),
            );
            if (isDisabled) {
              setDatabaseTableError(
                "This table is disabled. Contact administrator.",
              );
            }
          } catch {
            // Create still rejects a disabled table on submit
          }
        })
        .catch(() => {
          setDatabaseTableError(
            "Table name is invalid. Attributes cannot be loaded.",
          );
          setDatabaseTable("");
          if (tableEntrySourceRef.current === "manual") {
            setTableCommitState("failed");
          }
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [databaseTable]);

  useEffect(
    () => {
      if (putBucketsFn.isFulfilled) {
        setOpensucceessdataset(true);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [putBucketsFn.isFulfilled],
  );

  useEffect(() => {
    const sideBarMenuToHighlight = mainMenuItems
      .flatMap((item) => item.subMenu)
      .find((subItem) =>
        subItem.urls.some((url) => url.includes("/dataset-manager")),
      )?.label;

    setActiveSubItem(sideBarMenuToHighlight);
    setIsSideBarMenuDisabled({
      fed: false,
      cp: sessionFederationId === null ? true : false,
      cr: sessionFederationId === null ? true : false,
      pr: sessionFederationId === null ? true : false,
      ca: false,
      ah: sessionFederationId === null ? true : false,
      dm: sessionFederationId === null ? true : false,
    });
    setBreadcrumbItems([
      { label: "Discover", path: "/entry-hub?console=Discover" },
      { label: "Curation", path: "/federation-selection" },
      { label: "Federation Selection", path: "/federation-selection" },
      { label: "Dataset Manager", path: "/dataset-manager" },
      { label: "Create Dataset", path: "/create-dataset" },
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;

      if (dropdownRef.current && !dropdownRef.current.contains(target)) {
        setIsDropdownOpen(false);
      }
      if (
        matchIdDropdownRef.current &&
        !matchIdDropdownRef.current.contains(target)
      ) {
        setIsMatchIdDropdownOpen(false);
        setMatchIdSearchQuery("");
      }
      if (
        dbTableDropdownRef.current &&
        !dbTableDropdownRef.current.contains(target)
      ) {
        setIsDbTableDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const computeAnchorStyle = (
    ref: React.RefObject<HTMLDivElement>,
  ): React.CSSProperties => {
    if (!ref.current) return {};
    const rect = ref.current.getBoundingClientRect();
    const vw = window.innerWidth;
    const dropdownW = Math.min(580, vw - 16);
    const margin = 8;
    const left = Math.max(margin, Math.min(rect.left, vw - dropdownW - margin));
    return { position: "fixed", top: rect.bottom + 2, left };
  };

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const handleScroll = () => {
      if (isDbTableDropdownOpen)
        setDbTableDropdownStyle(computeAnchorStyle(dbTableDropdownRef));
      if (isMatchIdDropdownOpen)
        setMatchIdDropdownStyle(computeAnchorStyle(matchIdDropdownRef));
    };
    container.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      container.removeEventListener("scroll", handleScroll);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isDbTableDropdownOpen, isMatchIdDropdownOpen]);

  var tables = getTablesFn.data && getTablesFn.data;
  const identityTypeOptions: { key: string; value: string }[] =
    getConfigFn.data?.message?.canonical_identity_types ?? [];

  const handleFedSelect = (fed) => {
    const isAlreadySelected = selectedFeds.some(
      (f) => f.federation_id === fed.federation_id,
    );

    if (isAlreadySelected) {
      setSelectedFeds(
        selectedFeds.filter((f) => f.federation_id !== fed.federation_id),
      );
    } else {
      setSelectedFeds([
        ...selectedFeds,
        { Name: fed.name, federation_id: fed.federation_id },
      ]);
    }
  };

  const handleApplyManualTable = () => {
    const trimmed = dbTextInput.trim();
    if (!trimmed) return;
    tableEntrySourceRef.current = "manual";
    setTableCommitState("validating");
    setDatabaseTable(trimmed);
  };

  const handleClearManualTable = () => {
    setTableCommitState("idle");
    setDbTextInput("");
    setDatabaseTable("");
    setDatabaseTableError(null);
    setMatchId("");
    tableEntrySourceRef.current = "dropdown";
  };

  const handleBucketSubmit = async (e) => {
    e.preventDefault();
    const isValid = validateForm();
    if (!isValid) return;

    const bucketFormValues: any = Object.keys(BUCKET_FORM_FIELDS).reduce(
      (acc, cur) => {
        const k = BUCKET_FORM_FIELDS[cur];
        acc[k] = fields[k];
        return acc;
      },
      {},
    );

    const {
      identifier,
      // activation_table_name,
      activation_attribute,
      attributesChoose,
    } = bucketFormValues;

    if (attributesChoose !== undefined) {
      const clubArray = (attributesChoose) => {
        return attributesChoose.reduce((acc, val, ind) => {
          const index = acc.findIndex((el) => el.label === val.label);
          if (index !== -1) {
            var obj = [""];
            obj.push(val.values);
            obj.push(acc[index].values);
            obj.shift();
            acc.splice(index, 1);
            acc = [
              ...acc,
              {
                label: val.label,
                type: val.type,
                value: val.value,
                values: obj,
              },
            ];
          } else {
            acc.push(val);
          }
          return acc;
        }, []);
      };
      var results = clubArray(attributesChoose);
      var _finalAttributes = results.map((item) => {
        if (item.type === "varchar") {
          const values = item.values || "-";
          var set = [""];

          for (var i = 0; i < values.length; i++) {
            set.push(values[i].value);
          }
          set.shift();
          return { name: item.label, type: "string", values: set };
        }
        if (item.type === "int") {
          const values = item.values || "-";
          const values1 = item.modifier || "-";
          set = [""];
          set.push(values.value);
          set.push(values1.value);
          // for (i = 0; i < values.length; i++) {
          //   set.push(values[i].value);
          // }
          set.shift();
          return { name: item.label, type: "int", values: set };
        }
        const values = item.values || "-";
        var sets = [""];
        sets.push(values.value);

        sets.shift();
        return { name: item.label, type: item.type, values: sets };
      });
      _finalAttributes = [
        ..._finalAttributes,
        { name: identifier, type: "string", purpose: "identifier" },
      ];
    } else {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      _finalAttributes = [
        { name: identifier, type: "string", purpose: "identifier" },
      ];
    }

    const item = dataSourceData?.Items?.[0];

    const datasourceMetadata =
      item?.external_connector?.external === true
        ? item.external_connector
        : item?.connection_metadata;

    const body = {
      name: datasetName,
      is_live: true,
      external_organization_id: userOrganization,
      external_federation_id: localStorage.getItem("federationkey"),
      external_organization_name: userOrganizationName,
      external_data_source_id: sourceId,
      external_table_name: databaseTable,
      activation_table_name: databaseTable,
      external_database_name: datasourceMetadata?.database,
      external_schema_name: datasourceMetadata?.schema_name,
      activation_attribute: activation_attribute,
      identifier_type: matchId,
      canonical_identity_type: canonicalIdentityType,
      associated_federation_ids: selectedFeds.map((fed) => fed.federation_id),
      attributes: [
        ...Object.entries(attributesChips).map(([key, values]) => ({
          name: key.toLowerCase(),
          type:
            attributesType[key] === "int_range" ? "int" : attributesType[key],
          values,
        })),
        {
          name: matchId,
          type: "string",
          purpose: "identifier",
          canonical_identity_type: canonicalIdentityType,
        },
      ],
      user_details: {
        username: user?.given_name || user?.name || user?.email,
        organization_id: userOrgId,
        organization_name: userOrgName,
      },
    };
    console.log("[DatasetCreate] user_details payload:", body.user_details);
    try {
      await putBucketsFn.run({ body, organizationId: userOrganization });
    } catch (err: any) {
      showToast(err?.message || "Failed to create dataset.", "error");
    }
  };

  function goToDatasetHome() {
    history.push("/dataset-manager");
  }

  const storedPermissions = JSON.parse(
    localStorage.getItem("userPermissions") || "{}",
  );
  const isCreateDisabled =
    putBucketsFn.isFulfilled ||
    !datasetName?.trim() ||
    !databaseTable?.trim() ||
    !matchId?.trim() ||
    !canonicalIdentityType?.trim() ||
    selectedFeds.length === 0 ||
    !!databaseTableError;

  const tablesRefreshLabel = tablesError
    ? "Retry loading database tables"
    : "Reload the database tables";

  return storedPermissions?.datamanager === "no" ||
    storedPermissions?.datamanager === "read" ? (
    <PageNotFound />
  ) : (
    <LayoutContainer>
      {failureMessage && (
        <InfoPopup
          isOpen={Boolean(failureMessage)}
          onClose={() => {
            setFailureMessage(null);
            history.push("/dataset-manager");
          }}
          headerText="Information!"
          displayText={failureMessage}
          freeText
        />
      )}
      <div className={styles.pageWrapper}>
        <div className={styles.headerContainer}>
          <button
            className={styles.backButton}
            onClick={() => window?.history?.back()}
          >
            <img src={SimpleBackIcon} alt="back" />
            <span className={styles.backButtonText}>Back</span>
          </button>
        </div>

        <div className={styles.container} ref={containerRef}>
          {isPlatformOrAppAdmin && selectedOrganizationName && (
            <div className={`${styles.orgDetails}`}>
              Selected Organization:{" "}
              <span className={styles.orgName}>{selectedOrganizationName}</span>
            </div>
          )}
          <div className={styles.formRow}>
            <div className={styles.inputGroup}>
              <label className={styles.label}>
                Enter Dataset Name <span className={styles.required}>*</span>
              </label>
              <input
                type="text"
                value={datasetName}
                onChange={(e) => setDatasetName(e.target.value)}
                className={styles.textField}
              />
              <p className={styles.fieldHint}>
                A short, recognizable name used to identify this dataset.
              </p>
            </div>
            <div className={styles.inputGroup}>
              <label className={styles.label}>
                Federations <span className={styles.required}>*</span>
              </label>
              <div className={styles.fedListDropdown}>
                <div
                  className="dropdown"
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  ref={dropdownRef}
                >
                  <div className="dropdown-toggle">
                    {selectedFeds.length > 0
                      ? `Selected Federations (${selectedFeds.length})`
                      : "Select Federations"}
                    <DownIcon className="dropdown-icon" />
                  </div>
                  {isDropdownOpen && (
                    <div className="dropdown-options">
                      <div className={styles.fedSearchWrap}>
                        <input
                          className={styles.fedSearchInput}
                          placeholder="Search federations…"
                          onChange={handleFedSearch}
                          onClick={(e) => e.stopPropagation()}
                          autoFocus
                        />
                      </div>
                      {fedSearchLoading ? (
                        <div className={styles.fedSearchLoading}>Loading…</div>
                      ) : (
                        <>
                          {fedList?.map((fed) => {
                            const isSelected = selectedFeds.some(
                              (f) => f.federation_id === fed.federation_id,
                            );
                            return (
                              <div
                                key={fed.federation_id}
                                className={`dropdown-option ${
                                  isSelected ? "selected" : ""
                                }`}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleFedSelect(fed);
                                }}
                              >
                                <span className="dropdown-option-check">
                                  {isSelected ? (FEATURES.curationSkin ? <OI n="check" size="1em" /> : "✓") : ""}
                                </span>
                                <span>{fed.name}</span>
                              </div>
                            );
                          })}
                          {fedNextCursor && (
                            <div
                              className={styles.fedLoadMore}
                              onClick={(e) => {
                                e.stopPropagation();
                                loadFederations(
                                  fedSearchQueryRef.current,
                                  fedNextCursor,
                                );
                              }}
                            >
                              {fedLoadingMore ? "Loading…" : "Load more"}
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  )}
                </div>
              </div>
              <p className={styles.fieldHint}>
                Choose which federations can access and query this dataset.
              </p>
            </div>
          </div>

          <div className={styles.formRow}>
            <div className={styles.inputGroup}>
              <label className={styles.label}>
                Database Table <span className={styles.required}>*</span>
                {getTablesFn.isPending && (
                  <>
                    <span className={styles.labelSpinner} />
                    <span className={styles.loadingText}>
                      {tablesConnecting ? "Connecting..." : "Loading..."}
                    </span>
                  </>
                )}
                {!getTablesFn.isPending && (
                  <Tooltip text={`${tablesRefreshLabel}.`} placement="top">
                    <button
                      type="button"
                      className={styles.refreshIcon}
                      aria-label={tablesRefreshLabel}
                      disabled={!sourceId}
                      onClick={() => sourceId && loadDatabaseTables(sourceId)}
                    >
                      <ReloadIcon />
                    </button>
                  </Tooltip>
                )}
              </label>

              <div className={styles.gridDropdown}>
                <div
                  className={`dropdown${getTablesFn.isPending || dbTextInput.trim() !== "" || getTablesNameFn.isPending ? " dropdown-disabled" : ""}`}
                  ref={dbTableDropdownRef}
                  onClick={() => {
                    if (
                      !getTablesFn.isPending &&
                      dbTextInput.trim() === "" &&
                      !getTablesNameFn.isPending
                    ) {
                      if (!isDbTableDropdownOpen)
                        setDbTableDropdownStyle(
                          computeAnchorStyle(dbTableDropdownRef),
                        );
                      setIsDbTableDropdownOpen((o) => !o);
                    }
                  }}
                >
                  <div className="dropdown-toggle">
                    {databaseTable && dbTextInput.trim() === ""
                      ? databaseTable
                      : "Select a table"}
                    <DownIcon className="dropdown-icon" />
                  </div>
                  {isDbTableDropdownOpen && (
                    <div
                      className="dropdown-options"
                      style={dbTableDropdownStyle}
                    >
                      {(tables || []).map((t: string) => (
                        <div
                          key={t}
                          className={`dropdown-option${databaseTable === t ? " selected" : ""}`}
                          onClick={(e) => {
                            e.stopPropagation();
                            tableEntrySourceRef.current = "dropdown";
                            setTableCommitState("idle");
                            setDatabaseTable(t);
                            setDbTextInput("");
                            setDatabaseTableError(null);
                            setIsDbTableDropdownOpen(false);
                          }}
                        >
                          <span title={t}>{t}</span>
                          {databaseTable === t && (
                            <span className="dropdown-option-check">{(FEATURES.curationSkin ? <OI n="check" size="1em" /> : "✓")}</span>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              {tablesError && !getTablesFn.isPending && (
                <p className={styles.fieldError}>{tablesError}</p>
              )}
              <label className={styles.subLabel}>Or enter manually:</label>
              {tableCommitState === "validating" ||
              tableCommitState === "confirmed" ? (
                <div className={styles.tableCommitToken}>
                  <span className={styles.tableCommitTokenText}>
                    {dbTextInput}
                  </span>
                  {tableCommitState === "validating" && (
                    <span className={styles.labelSpinner} />
                  )}
                  {tableCommitState === "confirmed" && (
                    <span className={styles.tableCommitTokenCheck}>{(FEATURES.curationSkin ? <OI n="check" size="1em" /> : "✓")}</span>
                  )}
                  <button
                    type="button"
                    className={styles.tableCommitTokenRemove}
                    onClick={handleClearManualTable}
                    title="Clear and re-enter"
                  >
                    {(FEATURES.curationSkin ? <OI n="close" size="1em" /> : "×")}
                  </button>
                </div>
              ) : (
                <div className={styles.tableInputRow}>
                  <input
                    type="text"
                    className={`${styles.textField} ${styles.tableInputRowField}`}
                    placeholder="Type a table name"
                    value={dbTextInput}
                    disabled={
                      (databaseTable !== "" && dbTextInput.trim() === "") ||
                      getTablesNameFn.isPending
                    }
                    onChange={(e) => {
                      setDbTextInput(e.target.value);
                      setDatabaseTableError(null);
                      setTableCommitState("idle");
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && dbTextInput.trim()) {
                        e.preventDefault();
                        handleApplyManualTable();
                      }
                    }}
                  />
                  <button
                    type="button"
                    className={`${styles.tableApplyBtn}${dbTextInput.trim() === "" ? ` ${styles.tableApplyBtnHidden}` : ""}`}
                    onClick={handleApplyManualTable}
                    tabIndex={dbTextInput.trim() === "" ? -1 : 0}
                  >
                    Apply
                  </button>
                </div>
              )}
              {tableCommitState === "validating" ? (
                <p className={styles.validatingText}>
                  Validating table name...
                </p>
              ) : databaseTableError ? (
                <p className={styles.fieldError}>{databaseTableError}</p>
              ) : tableCommitState === "confirmed" ? (
                <p className={styles.tableConfirmedText}>
                  Table found. Columns loaded.
                </p>
              ) : dbTextInput.trim() !== "" ? (
                <p className={styles.tableApplyHint}>
                  Press Apply or Enter to confirm this table name.
                </p>
              ) : null}
              <p className={styles.fieldHint}>
                The source table that backs this dataset. Select from the
                dropdown or type the name directly.
              </p>
            </div>

            <div className={styles.inputGroup}>
              {selectedFeds.length > 0 && (
                <>
                  <label className={styles.label}>Selected Federations</label>
                  <div className={styles.fedChips}>
                    {selectedFeds.slice(0, 3).map((fed) => (
                      <div key={fed.federation_id} className={styles.fedChip}>
                        <span>{fed.Name}</span>
                        <button
                          className={styles.fedChipRemove}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleFedSelect({
                              name: fed.Name,
                              federation_id: fed.federation_id,
                            });
                          }}
                        >
                          {(FEATURES.curationSkin ? <OI n="close" size="1em" /> : "×")}
                        </button>
                      </div>
                    ))}
                    {selectedFeds.length > 3 && (
                      <div className={styles.fedChipMore}>
                        +{selectedFeds.length - 3} more
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>

            {/* Activation Table section commented out — not needed currently
            <div className={styles.inputGroup}>
              <label className={styles.label}>Activation Table</label>

              <select
                className={styles.selectField}
                value={actTextInput.trim() === "" ? activationTable : ""}
                onChange={(e) => {
                  const val = e.target.value;
                  setActivationTable(val);
                  setActTextInput("");
                  setActivationTableError(null);
                }}
                disabled={actTextInput.trim() !== "" || geActivationtTablesNameFn.isPending}
              >
                <option value="">
                  {getTablesFn.isPending ? "Loading tables..." : "Select a table"}
                </option>
                {(tables || []).map((t: string) => (
                  <option key={t} value={t}>{t}</option>
                ))}
              </select>
              {tablesError && (
                <p className={styles.fieldError}>{tablesError}</p>
              )}
              <label className={styles.subLabel}>Or enter manually:</label>
              <input
                type="text"
                className={styles.textField}
                placeholder="Type a table name"
                value={actTextInput}
                disabled={
                  (activationTable !== "" && actTextInput.trim() === "") ||
                  geActivationtTablesNameFn.isPending
                }
                onChange={(e) => {
                  setActTextInput(e.target.value);
                  if (activationTableError) setActivationTableError(null);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    setActivationTable(actTextInput.trim());
                  }
                }}
                onBlur={() => {
                  if (!geActivationtTablesNameFn.isPending) {
                    setActivationTable(actTextInput.trim());
                  }
                }}
              />
              {geActivationtTablesNameFn.isPending && actTextInput.trim() !== "" ? (
                <p className={styles.validatingText}>Validating...</p>
              ) : activationTableError ? (
                <p className={styles.fieldError}>{activationTableError}</p>
              ) : null}
            </div>
            */}
          </div>

          <div className={styles.formRow}>
            {/* ID Type */}
            <div className={styles.inputGroupFull}>
              <label className={styles.label}>
                Record Identifier <span className={styles.required}>*</span>
                {getTablesNameFn.isPending && (
                  <>
                    <span className={styles.labelSpinner} />
                    <span className={styles.loadingText}>Loading...</span>
                  </>
                )}
              </label>
              <div className={styles.gridDropdown}>
                <div
                  className={`dropdown${!databaseTable?.trim() ? " dropdown-disabled" : ""}`}
                  ref={matchIdDropdownRef}
                  onClick={() => {
                    if (databaseTable?.trim() && !getTablesNameFn.isPending) {
                      if (!isMatchIdDropdownOpen)
                        setMatchIdDropdownStyle(
                          computeAnchorStyle(matchIdDropdownRef),
                        );
                      setIsMatchIdDropdownOpen((o) => !o);
                    }
                  }}
                >
                  <div className="dropdown-toggle">
                    {matchId ||
                      (!databaseTable?.trim()
                        ? "Select a database table first"
                        : "Select a column…")}
                    <DownIcon className="dropdown-icon" />
                  </div>
                  {isMatchIdDropdownOpen && (
                    <div
                      className="dropdown-options"
                      style={matchIdDropdownStyle}
                    >
                      <div
                        style={{ gridColumn: "1 / -1", padding: "4px 6px 6px", borderBottom: "1px solid #e5e7eb" }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <input
                          className={styles.fedSearchInput}
                          placeholder="Search columns…"
                          value={matchIdSearchQuery}
                          onChange={(e) => setMatchIdSearchQuery(e.target.value)}
                          onClick={(e) => e.stopPropagation()}
                          autoFocus
                        />
                      </div>
                      {(attributesResult ?? [])
                        .filter((item) =>
                          item.Name.toLowerCase().includes(matchIdSearchQuery.toLowerCase()),
                        )
                        .map((item) => (
                          <div
                            key={item.Name}
                            className={`dropdown-option${matchId === item.Name ? " selected" : ""}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              setMatchId(item.Name);
                              setCanonicalIdentityType("");
                              setIsMatchIdDropdownOpen(false);
                              setMatchIdSearchQuery("");
                            }}
                          >
                            <span title={item.Name}>{item.Name}</span>
                            {matchId === item.Name && (
                              <span className="dropdown-option-check">{(FEATURES.curationSkin ? <OI n="check" size="1em" /> : "✓")}</span>
                            )}
                          </div>
                        ))}
                      {attributesResult &&
                        attributesResult.filter((item) =>
                          item.Name.toLowerCase().includes(matchIdSearchQuery.toLowerCase()),
                        ).length === 0 && (
                          <div
                            style={{
                              gridColumn: "1 / -1",
                              padding: "10px 8px",
                              color: "#9ca3af",
                              fontStyle: "italic",
                              fontSize: "var(--font-md)",
                              fontFamily: "var(--font-data)",
                            }}
                          >
                            No columns match your search.
                          </div>
                        )}
                    </div>
                  )}
                </div>
              </div>
              <p className={styles.fieldHint}>
                The column used to uniquely identify each record.
              </p>
            </div>

            {/* Canonical Identity Type */}
            <div className={styles.inputGroup}>
              <label className={styles.label}>
                ID Type <span className={styles.required}>*</span>
              </label>
              {!matchId?.trim() ? (
                <p className={styles.pillPlaceholder}>
                  Please select an ID type first.
                </p>
              ) : (
                <>
                  <div className={styles.pillGroup}>
                    {identityTypeOptions.map((item) => (
                      <button
                        key={item.key}
                        type="button"
                        className={`${styles.identityPill} ${
                          canonicalIdentityType === item.key
                            ? styles.identityPillActive
                            : ""
                        }`}
                        onClick={() => setCanonicalIdentityType(item.key)}
                      >
                        {item.value}
                      </button>
                    ))}
                  </div>
                  <p className={styles.pillHint}>
                    Maps the ID Type to a standard identity type.
                  </p>
                </>
              )}
            </div>

            {/* Activation ID section commented out — not needed currently
            <div className={styles.inputGroup}>
              <label className={styles.label}>Activation ID</label>
              <select
                className={styles.selectField}
                value={activationId}
                onChange={(e) => setActivationId(e.target.value)}
                disabled={
                  !activationAttrResult || activationAttrResult.length === 0
                }
              >
                <option value="">
                  {!activationAttrResult || activationAttrResult.length === 0
                    ? "Please select an activation table."
                    : "Select"}
                </option>

                {activationAttrResult?.map((item) => (
                  <option key={item.Name} value={item.Name}>
                    {item.Name}
                  </option>
                ))}
              </select>
            </div>
            */}
          </div>

          <div className={styles.attributeActions}>
            <div className={styles.addAttrGroup}>
              <button
                className={styles.addAttributesBtn}
                onClick={() => {
                  if (
                    databaseTable?.trim() &&
                    matchId?.trim() &&
                    canonicalIdentityType?.trim()
                  ) {
                    setShowAttributePopup(true);
                  }
                }}
                disabled={
                  !databaseTable?.trim() ||
                  !matchId?.trim() ||
                  !canonicalIdentityType?.trim()
                }
              >
                + Add Attributes
              </button>
              <span className={styles.addAttrHint}>
                — Define filterable values for each column in this dataset.
              </span>
            </div>
            {attributesChips && Object.keys(attributesChips).length > 0 && (
              <button
                className={styles.attributesAddedBadge}
                onClick={() => setShowAttributePopup(true)}
              >
                <Tooltip
                text="Click to view and manage all attributes selected so far"
                placement="top"
                maxWidth={220}
              >
                <InfoIcon className={styles.info} />
              </Tooltip>
                {Object.keys(attributesChips).length} Attribute
                {Object.keys(attributesChips).length !== 1 ? "s" : ""} Added
              </button>
            )}
          </div>

          <div className={styles.buttonGroup}>
            <button className={styles.cancelButton} onClick={goToDatasetHome}>
              Cancel
            </button>
            <button
              className={styles.createButton}
              onClick={handleBucketSubmit}
              disabled={isCreateDisabled}
            >
              Create Dataset
            </button>
          </div>
        </div>
        {attributePopup && (
          <AttributePopup
            onClose={() => setShowAttributePopup(false)}
            onSave={() => setShowAttributePopup(false)}
            setAttributesChips={setAttributesChips}
            popupRef={popupRef}
            databaseTable={databaseTable}
            SourceId={sourceId}
            setAttributeType={setAttributeType}
            matchId={matchId}
            initialChips={
              Object.keys(attributesChips).length > 0
                ? attributesChips
                : undefined
            }
            initialAttributeTypes={
              Object.keys(attributesType).length > 0
                ? attributesType
                : undefined
            }
          />
        )}
        {opensucceessDataset && (
          <InfoPopup
            isOpen={Boolean(opensucceessDataset)}
            onClose={() => {
              setOpensucceessdataset(false);
              history.push("/dataset-manager", {
                selectedOrgId: userOrganization,
              });
            }}
            headerText="Success!"
            displayText="Dataset Created succesfully!"
            freeText
          />
        )}
      </div>
    </LayoutContainer>
  );
};

export default DatasetCreatePage;
